export default __webpack_public_path__ + "static/media/logo2.1da7daf2.png";